import { CrossSelling } from '../../models/form-state.model';

export interface CrossSellingState {
  CrossSelling: CrossSelling;
}

export const initialState: CrossSellingState = {
  CrossSelling: {
    Information: undefined
  }
};
